import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useSystemStore } from '../../stores/SystemStore';
import BasicTransition from '../BasicTransition';
import CarLoader from '../CarLoader';
import Center from '../Center';
import { Header } from '../Header/Header';
import { MainContentLayout, OutAppLayoutContainer } from './styles';

const OutAppLayout: React.FC = () => {
	const loginFlowVisible = useSystemStore(state => state.loginFlowVisible);
	return (
		<OutAppLayoutContainer $hasHeader={loginFlowVisible}>
			{loginFlowVisible && <Header isLoginFlow />}
			<MainContentLayout>
				<Suspense
					fallback={
						<BasicTransition>
							<Center>
								<CarLoader size={1} />
							</Center>
						</BasicTransition>
					}
				>
					<Outlet />
				</Suspense>
			</MainContentLayout>
		</OutAppLayoutContainer>
	);
};

export default OutAppLayout;
